<template>
	
	<form @submit.prevent="updatePerfil()">
		
		<v-card light class="pa-5" elevation="5">

			<div class="text-center">
				<v-icon size="100">mdi-account</v-icon>
			</div>

			<v-text-field
	      label="Nombre completo"
	      v-model="user.name" 
	      filled
	      light
	      required
	    ></v-text-field> 

      <v-text-field
        label="Nombre de tu negocio"
        v-model="user.name_business"
        filled
        light
        required
      ></v-text-field> 	

      <v-text-field
      	placeholder="+52"
				type="number"
				maxlength="10"
        label="Telefono"
        v-model="user.phone"
        filled
        light
        required
      ></v-text-field> 

      <v-btn dark large block type="submit" id="perfil-form-btn">
	      Actualizar
	    </v-btn>

		</v-card>

	</form>

</template>


<script>
	
	import UserService from '@/shared/services/UserService'


	export default 
	{
		
		data() {
			return {
				user: {
					token: localStorage.getItem('token'),
					name: null,
					name_business: null,
					phone: null
				}
			}
		},

		created() {
			this.getUser();
		},

		methods: {

			async getUser()
			{
				const resp = await UserService.getUser()

				this.user.name = resp.data.customer.name
				this.user.name_business = resp.data.customer.name_business
				this.user.phone = resp.data.customer.phone
			},

			async updatePerfil()
			{
    		const resp = await UserService.updatePerfil(this.user)

    		if(resp.data == 'OK')
    			SwalAlert('', 'Perfil actualizado', 'success')
    		else
    			SwalAlert('', 'Ha ocurrido un error, por favor intenta de nuevo')
			}

		}

	}

</script>